import { render, staticRenderFns } from "./NotQualifiedNum.vue?vue&type=template&id=a83509c0&scoped=true&"
import script from "./NotQualifiedNum.vue?vue&type=script&lang=js&"
export * from "./NotQualifiedNum.vue?vue&type=script&lang=js&"
import style0 from "./NotQualifiedNum.vue?vue&type=style&index=0&id=a83509c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83509c0",
  null
  
)

export default component.exports